'use strict';

const tooltipTokens = (theme) => ({
    tooltipOffsetX: theme.space.component.x.s,
    tooltipOffsetY: theme.space.component.y.s,
    tooltipPaddingX: theme.space.component.x.s,
    tooltipPaddingY: theme.space.component.y.s,
    tooltipBackgroundColor: theme.colors.body.text,
    tooltipTextColor: theme.colors.body.background,
    tooltipRadius: theme.radiuses.m,
    tooltipZIndex: theme.zIndices.tooltip,
});

exports.tooltipTokens = tooltipTokens;
//# sourceMappingURL=tooltip.js.map
